import { render, staticRenderFns } from "./SCR_MBC_0113_03.vue?vue&type=template&id=77192958&"
import script from "./SCR_MBC_0113_03.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0113_03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports